import { FormEvent, useContext, useEffect, useState } from 'react'
import { Button, Loader } from '../Styles'
import { ModalEstadoContext } from '../../contexts/ModalEstado';
import { toast } from 'react-toastify';
import { criptografarDado, descriptografarDado } from '../../helpers';
import { listaDesafios, membrosResponsaveis, propsPlanoAcao } from '../../interfaces/desafios';
import { atualizarPlanoAcao, buscarDesafio, cadastrarPlanoAcao } from '../../services/desafios';
import { listarMembrosProjeto } from '../../services/projetos';
import { useLocation } from 'react-router-dom';

function ModalPlanoAcao({ planoAcao }: propsPlanoAcao) {
  const { modalExibir, atualizarDados, atualizarInformacoes } = useContext(ModalEstadoContext)

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto")
  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const [processando, setProcessando] = useState(false);
  const [titulo, setTitulo] = useState(planoAcao?.titulo || "");
  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);
  const [responsavel, setResponsavel] = useState(planoAcao?.idResponsavel?.toString() || "");
  const [descricao, setDescricao] = useState(planoAcao?.descricao || "");
  const [dataInicio, setDataInicio] = useState<string>(planoAcao?.dataInicio || "");
  const [dataTermino, setDataTermino] = useState<string>(planoAcao?.dataTermino || "");
  const [idDesafioPlanoAcao, setIdDesafioPlanoAcao] = useState(planoAcao?.desafio.id || "");
  const [desafios, setDesafios] = useState<listaDesafios[]>([]);
  const [situacao, setSituacao] = useState(planoAcao?.situacao);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado");

      const payload = {
        idProjeto: descriptografarDado(idProjeto),
        idDesafio: idDesafioPlanoAcao,
        idResponsavel: responsavel,
        titulo,
        descricao,
        dataInicio,
        dataTermino
      }
      const resposta = await cadastrarPlanoAcao(payload)

      if (resposta.status === 201) {
        atualizarDados()
        setProcessando(false);
        toast.success("Ação Criado com Sucesso.")
        modalExibir("")
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Cadastrar Ação.")
    }
  }

  const updateSubmit = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)
    try {
      if (!planoAcao?.id) return toast.error("Plano de ação não encontrado");
      const idPlanoAcaoCript = criptografarDado(planoAcao?.id.toString())

      const payload = {
        idResponsavel: responsavel, situacao, titulo, descricao, dataInicio, dataTermino
      }
      const resposta = await atualizarPlanoAcao(idPlanoAcaoCript, payload)

      if (resposta.status === 200) {
        atualizarDados()
        setProcessando(false);
        toast.success("Plano de Ação Atualizado com Sucesso.")
        modalExibir("")
      }
    } catch (error) {
      setProcessando(false)
      toast.error("Erro ao Atualizar Plano de Ação.")
    }
  }

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")
      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }

      } catch (error) {
        return alert('Falha ao Listar os Responsáveis')
      }
    };

    listarMembrosResponsaveis();
  }, [atualizarInformacoes]);

  useEffect(() => {
    const listarDesafios = async () => {
      setProcessando(true);
      if (!idProjeto) return toast.error("Projeto não encontrado.")

      try {
        const response = await buscarDesafio(idProjeto);
        if (response.data && response.data.length > 0) {
          setDesafios(response.data);
          return setProcessando(false);
        }
        setProcessando(false);
        return toast.warn("Não foram encontrados os Desafios Cadastrados. Por favor, Cadastre um Desafio")
      } catch (error) {
        toast.error('Erro ao listar desafios.')
        return setProcessando(false);
      }
    };

    listarDesafios();
  }, [atualizarInformacoes]);

  return (
    <div id='fundoModal'>
      <section className={'containerModalCentro'}>
        <span className='novoContainerTitulo'>
          <h1>{planoAcao ? "Editar Plano de Ação" : "Cadastrar Plano de Ação"}</h1>
        </span>
        <form className="formModalNovo" onSubmit={(e) => planoAcao ? updateSubmit(e) : handleSubmit(e)}>
          {!planoAcao && <section>
            <span>
              <label htmlFor="">Selecione um DesaFio</label>
              <select name="" id="" onChange={(e) => { setIdDesafioPlanoAcao(e.target.value) }} value={idDesafioPlanoAcao} required>
                <option value="" disabled>Selecione um Desafio</option>
                {desafios.map((desafio) => (
                  <option value={desafio.id.toString()} key={desafio.id}>{desafio.titulo}</option>
                ))}
              </select>
            </span>
          </section>}
          <section>
            <span>
              <label htmlFor="">Responsável</label>
              <select name="" id="" onChange={(e) => { setResponsavel(e.target.value) }} value={responsavel} required>
                <option value="" disabled>Selecione um Responsavel</option>
                {responsaveis.map((responsavel) => (
                  <option value={responsavel.usuario.id.toString()} key={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                ))}
              </select>
            </span>
          </section>
          <section>
            <span>
              <label htmlFor="">Titulo</label>
              <input type="text" placeholder='Digite o titulo do Plano de Ação' onChange={(e) => { setTitulo(e.target.value) }} maxLength={100} defaultValue={planoAcao?.titulo} required />
            </span>
          </section>
          <section>
            <span>
              <label htmlFor="">Descrição</label>
              <textarea rows={10} cols={45} className='areaTexto' onChange={(e) => { setDescricao(e.target.value) }} maxLength={500} placeholder='Digite a Descrição' defaultValue={planoAcao?.descricao} required></textarea>
            </span>
          </section>
          {!!planoAcao && <section>
            <span>
              <label htmlFor="">Situação</label>
              <select name="" id="" onChange={(e) => { setSituacao(e.target.value) }} defaultValue={situacao} required>
                <option value="Pendente">Pendente</option>
                <option value="Iniciada">Iniciada</option>
                <option value="Finalizada">Finalizada</option>
              </select>
            </span>
          </section>}
          <section>
            <span>
              <label htmlFor="">Data Inicio</label>
              <input type="date" onChange={(e) => { setDataInicio(e.target.value) }} defaultValue={dataInicio} required />
            </span>
          </section>
          <section>
            <span>
              <label htmlFor="">Data Término</label>
              <input type="date" onChange={(e) => { setDataTermino(e.target.value) }} min={dataInicio} defaultValue={dataTermino} required />
            </span>
          </section>
          <span className="botoesContainer">
            <Button type="button" cor="cancelar" isLoading={processando} onClick={() => { modalExibir(""); }}>
              Cancelar
            </Button>
            {!usuarioExterno && <Button type="submit" cor="salvar" isLoading={processando}>
              {!processando && "Salvar"}
              {processando && <Loader isLoading={processando} />}
            </Button>}
          </span>
        </form>
      </section>
    </div>
  )
}

export default ModalPlanoAcao